import React from 'react';
import { Button } from '@/components/ui/button';
import { LogOut, Bell, Shield, Globe } from 'lucide-react';
import ProfileSection from './ProfileSection';
import { Card, CardContent } from '@/components/ui/card';
import { useAuth } from '@/contexts/AuthContext';
const ProfileSettings: React.FC = () => {
  const {
    signOut
  } = useAuth();
  const handleSignOut = async () => {
    try {
      await signOut();
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };
  return <ProfileSection title="Settings">
      
      
      <div className="mt-8">
        <Button variant="outline" className="border-red-900/50 text-red-500 hover:bg-red-950/30 hover:text-red-400 hover:border-red-900/70" onClick={handleSignOut}>
          <LogOut className="mr-2 h-4 w-4" />
          Sign Out
        </Button>
      </div>
    </ProfileSection>;
};
export default ProfileSettings;